import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Questions = () => {
    return (
        <div className='quest'>
            <div className='max-width'>
                <Container>
                    <Row className='row1'>
                        <Col>
                            <img src='questimg.png' alt='' />
                        </Col>
                        <Col>
                            <Container>
                                <Row className='rowH'>
                                    Questions Udeline wants to ask you
                                </Row>
                                <Row >
                                    <div className='rowc'>
                                        Why would you like to waste your crucial time and effort in something you don’t like?
                                    </div>
                                </Row>
                                <Row >
                                    <div className='rowc'>
                                        Why do you need to run in the same direction where everyone is going?
                                    </div>
                                </Row>
                                <Row >
                                    <div className='rowc'>
                                        Why don’t you choose a career in which you have an interest in and make your life easier?
                                    </div>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
                <div className='book'>
                    <div className='bookcont'>
                        <h1>Begin your Journey towards Dream With us</h1>
                        <div className='bookbtn'>
                            <Button>Book a basic Counselling session</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Questions;